module.exports = __webpack_public_path__ + "media/images/countrysquared/me-a946d6161977649da54cf96298719ee9.svg";